/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortOrders } from './Table';
import { type DynamicObjectInterface, type SortingDataInterface } from './types/propType';

export const isRowCheckedOrDisabled = (
  row: DynamicObjectInterface,
  rowKey: string,
  disabledItems: any[],
  selectedKeys: string[],
) => selectedKeys.includes(row[rowKey]) || disabledItems.includes(row[rowKey]);

export const areAllChildrenChecked = (
  children: DynamicObjectInterface[],
  rowKey: string,
  disabledItems: any[],
  selectedKeys: string[],
) =>
  children.every((child: DynamicObjectInterface) => isRowCheckedOrDisabled(child, rowKey, disabledItems, selectedKeys));

export const areAnyChildrenChecked = (
  children: DynamicObjectInterface[],
  rowKey: string,
  disabledItems: any[],
  selectedKeys: string[],
) =>
  children.some((child: DynamicObjectInterface) => isRowCheckedOrDisabled(child, rowKey, disabledItems, selectedKeys));

export const getCheckboxStates = (
  tableData: DynamicObjectInterface[],
  rowKey: string,
  disabledItems: any[],
  selectedKeys: string[],
) => {
  const allChecked = tableData.every(
    (parent: DynamicObjectInterface) =>
      isRowCheckedOrDisabled(parent, rowKey, disabledItems, selectedKeys) &&
      (!parent.children || areAllChildrenChecked(parent.children, rowKey, disabledItems, selectedKeys)),
  );

  const anyChecked = tableData.some(
    (parent) =>
      isRowCheckedOrDisabled(parent, rowKey, disabledItems, selectedKeys) ||
      (parent.children && areAnyChildrenChecked(parent.children, rowKey, disabledItems, selectedKeys)),
  );

  return { allChecked, anyChecked };
};

export const handleSorting = (sortingData: SortingDataInterface, tableData: DynamicObjectInterface[]) => {
  const [sortField] = Object.keys(sortingData);
  const sortOrder = sortingData[sortField as string];
  if (sortField) {
    return sortData(tableData, sortField, sortOrder as string);
  }
  return tableData;
};

const sortData = (tableData: DynamicObjectInterface[], sortField: keyof SortingDataInterface, sortOrder: string) => {
  const sortedData = [...tableData].sort((a, b) => {
    if (!a[sortField] && !b[sortField]) {
      return 0;
    } else if (!a[sortField]) {
      return sortOrder === SortOrders.ASC ? -1 : 1;
    } else if (!b[sortField]) {
      return sortOrder === SortOrders.ASC ? 1 : -1;
    }

    return (
      a[sortField].toString().localeCompare(b[sortField].toString(), 'en', {
        numeric: true,
      }) * (sortOrder === SortOrders.ASC ? 1 : -1)
    );
  });
  return sortedData;
};
